import React from 'react';
import { Modal, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { setShortcutModalOpen } from '@/store/actions/cmme';
import { CloseIcon, Label } from '@/components';
import {
  SelectNextSectionIcon,
  SectionSelectionIcon,
  UndoIcon,
  RedoIcon,
  SelectAllSectionsIcon,
  CopySectionIcon,
  PasteSectionIcon,
  PasteContentIcon,
  DeleteContentIcon,
  DeleteSectionIcon,
  ZoomInIcon,
  ZoomOutIcon,
  ZoomResetIcon,
  EscIcon,
  EnterIcon,
  IncrementValueIcon,
  DuplicateContentIcon
} from './Icons';
import { ModalWrapperStyled, RowStyled } from './styles';

const KeyboardShortcutsModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const shortcuts = [
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.nextElement',
        defaultMessage: 'Select next element',
      }),
      icon: <SelectNextSectionIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.arrowNavigation',
        defaultMessage: 'Navigation (selection of elements)',
      }),
      icon: <SectionSelectionIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.incrementValue',
        defaultMessage: 'Increment content',
      }),
      icon: <IncrementValueIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'app.editor.sidebar.undo',
        defaultMessage: 'Undo',
      }),
      icon: <UndoIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.allElements',
        defaultMessage: 'Select all element',
      }),
      icon: <SelectAllSectionsIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'app.editor.menu.autofillCopy',
        defaultMessage: 'Copy',
      }),
      icon: <CopySectionIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'app.editor.sidebar.paste',
        defaultMessage: 'Paste',
      }),
      icon: <PasteSectionIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.pasteContent',
        defaultMessage: 'Paste only content',
      }),
      icon: <PasteContentIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.duplicateContent',
        defaultMessage: 'Duplicate content',
      }),
      icon: <DuplicateContentIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'app.editor.modal.deleteContent',
        defaultMessage: 'Delete content',
      }),
      icon: <DeleteContentIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'app.editor.modal.deleteSelectedElement',
        defaultMessage: 'Delete selected element',
      }),
      icon: <DeleteSectionIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.enterEditMode',
        defaultMessage: 'Enter into edit mode',
      }),
      icon: <EnterIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.exitEditMode',
        defaultMessage: 'Exit edit mode',
      }),
      icon: <EscIcon />,
    },
    {
      id: uuidv4(),
      label: intl.formatMessage({
        id: 'cmme.keyboardShortcuts.removeSelection',
        defaultMessage: 'Remove selection from elements',
      }),
      icon: <EscIcon />,
    },
  ];

  const handleCancelClick = () => {
    dispatch(setShortcutModalOpen(false));
  };

  return (
    <Modal open onClose={handleCancelClick}>
      <ModalWrapperStyled>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '30px 30px 20px',
          }}
        >
          <Label
            variant="meduim"
            fontSize={24}
          >
            <FormattedMessage
              id="debug.keyboardShortcuts"
              defaultMessage="Keyboard shortcuts"
            />
          </Label>
          <Box
            sx={{ display: 'flex', cursor: 'pointer' }}
            onClick={handleCancelClick}
          >
            <CloseIcon />
          </Box>
        </Box>

        <Box
          sx={{
            overflow: 'auto',
            maxHeight: '80vh',
            padding: '0px 0px 30px 30px',
          }}
        >
          {shortcuts.map(item => {
            return (
              <RowStyled key={item.id}>
                <span>{item.label}</span>
                {item.icon}
              </RowStyled>
            );
          })}
        </Box>
      </ModalWrapperStyled>
    </Modal>
  );
};

export default KeyboardShortcutsModal;
